import React from 'react';
import PropTypes from 'prop-types';
import './_ModalSection.scss';

const ModalSection = props => {
  return (
    <div className="ModalSection">
      <div className="ModalSection__title">
        {props.title}
        {props.subtitle && <div className="ModalSection__subtitle">{props.subtitle}</div>}
      </div>
      <div className="ModalSection__main">{props.children}</div>
    </div>
  );
};

ModalSection.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

export default ModalSection;
